import { createPaginator } from "@smithy/core";
import { ListMediaAnalysisJobsCommand, } from "../commands/ListMediaAnalysisJobsCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListMediaAnalysisJobs = createPaginator(RekognitionClient, ListMediaAnalysisJobsCommand, "NextToken", "NextToken", "MaxResults");
